import React, { memo, useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {
  getColumnsWidthStyles,
  getSharedAccordionStyles,
} from 'app/pages/loanApplication/LoanApplication.sharedStyles';
import Accordion from 'app/shared/components/common/Accordion';
import Incomes from 'app/shared/components/reports/incomes';
import dayjs from 'dayjs';
import withLoading, { WithLoadingPropTypes } from 'hocs/withLoading';
import PropTypes from 'prop-types';
import { compose } from 'redux';

import { COMMON_DATETIME_FORMAT } from 'constants/date';

import { getUwReportByReportIdAction } from 'store/loanApplications/actions';

import { UnderwritingTestIds } from '../../Underwriting.testIds';

const UWReportItem = ({ report, setIsLoading }) => {
  const dispatch = useDispatch();

  const theme = useTheme();
  const classes = useMemo(() => getSharedAccordionStyles(theme), [theme]);
  const columnsStyles = useMemo(() => getColumnsWidthStyles(theme, { columns: 4 }), [theme]);

  const accordionSx = useMemo(
    () => [classes.accordion, classes.root],
    [classes.accordion, classes.root],
  );

  const onChange = useCallback(
    (__, isExpanded) => {
      if (isExpanded) {
        setIsLoading(true);
        dispatch(getUwReportByReportIdAction({ reportId: report.reportId })).finally(() =>
          setIsLoading(false),
        );
      }
    },
    [setIsLoading, dispatch, report.reportId],
  );

  return (
    <Box sx={classes.accordionWrapper}>
      <Accordion
        unmountOnExit
        bottom={<Incomes incomes={report.incomesSection} />}
        className="shadow-none"
        data-testid={UnderwritingTestIds.getUwReportItemId(report.reportId)}
        defaultExpanded={false}
        id={`report-${report.reportId}`}
        isWithDivider={false}
        sx={accordionSx}
        top={
          <Box className="w-full" sx={classes.accordionTop}>
            <Box className="flex md:hidden flex-col" sx={columnsStyles.wrapper}>
              <Typography variant="regular14">Date</Typography>
              <Typography variant="regular14">Informational</Typography>
              <Typography variant="regular14">Warning</Typography>
              <Typography variant="regular14">Severe</Typography>
            </Box>

            <Box
              className="flex flex-col md:flex-row"
              data-testid={UnderwritingTestIds.getUwReportItemHeaderId(report.reportId)}
              sx={columnsStyles.wrapper}
            >
              <Typography variant="regular14">
                {dayjs(report.createdDate).format(COMMON_DATETIME_FORMAT)}
              </Typography>
              <Typography variant="regular14">{report.informationalAlerts}</Typography>
              <Typography variant="regular14">{report.warningAlerts}</Typography>
              <Typography variant="regular14">{report.severeAlerts}</Typography>
            </Box>
          </Box>
        }
        onChange={onChange}
      />
    </Box>
  );
};

UWReportItem.propTypes = {
  ...WithLoadingPropTypes,
  report: PropTypes.object.isRequired,
};

export default compose(withLoading, memo)(UWReportItem);
